import { Button, Row } from 'antd';
import { memo, useCallback } from 'react';
import { IBaseQuery } from 'src/types';

interface IProps {
  page: number;
  take: number;
  total: number;
  lastIds: string[];
  onChangePage: (value: number) => void;
  setParams: (value: any) => void;
  params: IBaseQuery;
  setLastIds: (value: any) => void;
  setIsNextPage: (value: boolean) => void;
  handleNextPageRowSelection?: () => void;
}

function BasePaginate({
  lastIds,
  page = 1,
  params,
  setLastIds,
  onChangePage,
  setParams,
  take,
  total,
  handleNextPageRowSelection,
  setIsNextPage,
}: IProps) {
  const totalPage = Math.ceil(total / take);

  const onNextPage = () => {
    setParams({
      ...params,
      cursor: lastIds[lastIds.length - 1],
    });
    onChangePage(page + 1);
    setIsNextPage(true);
    if (handleNextPageRowSelection) handleNextPageRowSelection();
  };

  const onPrevPage = useCallback(() => {
    /**
     * page = 1 => lastIds = [id1] => next page 2 = id1
     * page = 2 => lastIds = [id1, id2] => next page 3 = id2
     * page = 3 => lastIds = [id1, id2, id3] => next page 4 = id3
     */
    if (lastIds.length <= 1) return;

    const cursor: string | undefined = lastIds.length === 2 ? undefined : lastIds[lastIds.length - 3];

    setParams({
      ...params,
      cursor,
    });
    onChangePage(page - 1);
    setLastIds((prev: string[]) => {
      const newIds = [...prev];
      newIds.pop();

      return newIds;
    });
  }, [lastIds, page]);

  return (
    <Row justify="center" align="middle" style={{ marginTop: 12 }}>
      <Button disabled={page <= 1} onClick={onPrevPage}>
        Trang trước
      </Button>
      <span style={{ margin: '0 12px' }}>{`${(page - 1) * take + 1} - ${
        page * take > total ? total : page * take
      }/${total} bản ghi`}</span>
      <Button disabled={page >= totalPage} onClick={onNextPage}>
        Trang sau
      </Button>
    </Row>
    // <div className="text-center">
    //   <div className="filter-pagination mb-3">
    //     <Button className="me-2" variant="secondary btn-rounded" disabled={page <= 1} onClick={onPrevPage}>
    //       <span className="btn-icon-start text-secondary">
    //         <i className="fa fa-arrow-left" />
    //       </span>
    //       Trang trước
    //     </Button>
    //     <Button className="me-2" variant="secondary btn-rounded" disabled={page >= totalPage} onClick={onNextPage}>
    //       Trang sau
    //       <span className="btn-icon-start text-secondary next-button">
    //         <i className="fa fa-arrow-right" />
    //       </span>
    //     </Button>
    //   </div>
    // </div>
  );
}

BasePaginate.defaultProps = {
  handleNextPageRowSelection: undefined,
};

export default memo(BasePaginate);
